import React from 'react';
import { Button, Space } from 'antd';
import {
  VideoCameraOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import { useTranslation } from '../../../hooks/useTranslation';

export interface ScheduledQuickActionsProps {
  appointment: {
    id: string;
    status: string;
  };
  loadingStates: {
    starting?: boolean;
    updating?: boolean;
    cancelling?: boolean;
    markingNoShow?: boolean;
  };
  handlers: {
    onStartVideoCall: () => void;
    onMarkConsulted: () => void;
    onCancelAppointment: () => void;
    onMarkNoShow?: () => void;
  };
  showNoShowButton?: boolean;
}

const ScheduledQuickActions: React.FC<ScheduledQuickActionsProps> = ({
  appointment,
  loadingStates,
  handlers,
  showNoShowButton = false
}) => {
  const { t } = useTranslation();

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      {/* Start Video Call Button */}
      <Button
        type="primary"
        icon={<VideoCameraOutlined />}
        block
        onClick={handlers.onStartVideoCall}
        loading={loadingStates.starting}
      >
        {t('appointments.startVideoCall')}
      </Button>

      {/* Mark Consulted Button */}
      <Button
        type="primary"
        icon={<CheckCircleOutlined />}
        block
        onClick={handlers.onMarkConsulted}
        loading={loadingStates.updating}
      >
        {t('appointments.markConsulted') || 'Consulted'}
      </Button>

      {/* Mark No-Show Button (Optional) */}
      {showNoShowButton && handlers.onMarkNoShow && (
        <Button 
          icon={<ExclamationCircleOutlined />} 
          block
          onClick={handlers.onMarkNoShow}
          loading={loadingStates.markingNoShow}
        >
          {t('appointments.markNoShow') || 'Mark No-Show'}
        </Button>
      )}

      {/* Cancel Appointment Button */}
      <Button
        danger
        icon={<CloseCircleOutlined />}
        block
        onClick={handlers.onCancelAppointment}
        loading={loadingStates.cancelling}
      >
        {t('appointments.cancel')}
      </Button>
    </Space>
  );
};

export default ScheduledQuickActions;
